
namespace Serenity {
    
    export interface HeadersFiltersMixinOptions {
        grid: Serenity.DataGrid<any, any>;
    }

    /**
     * A mixin that can be applied to a DataGrid for column filters functionality
     */
    export class HeaderFiltersMixin {

        constructor(options: HeadersFiltersMixinOptions) {
            
            var skipColumnFilters: Slick.Column = null;
            var cache: any = {};

            var filterPlugin = new Slick.Plugins.HeaderFilters({
                getFilterValues: (col: Slick.Column, done: (vals: any[]) => void) => {
                    if (!options.grid.view.url ||
                        !options.grid.view['getPagingInfo']().rowsPerPage ||
                        (options.grid.view.getLength() == 0 &&
                         !Q.any(options.grid.slickGrid.getColumns(), 
                            x => x.filterValues != null && x.filterValues.length > 0))) {
                        return null;
                    }

                    skipColumnFilters = col;
                    try {
                        if (!(options.grid as any).onViewSubmit()) {
                            done([]);
                            return;
                        }
                    }
                    finally {
                        skipColumnFilters = null;
                    }

                    var req = Q.deepClone(options.grid.view.params) as ListRequest;
                    req.DistinctFields = [col.field];
                    req.Skip = 0;
                    req.Take = 0;
                    var cacheKey = $.toJSON(req);
                    var cached = cache[cacheKey];
                    if (cached && cached.expires > new Date().getTime())
                        done(cached.value);
                    else {
                        Q.serviceCall({
                            request: req,
                            url: options.grid.view.url,
                            onSuccess: (response: ListResponse<any>) => {
                                cache[cacheKey] = {
                                    value: response.Values,
                                    expires: new Date().getTime() + 1000 * 30
                                };
                                done(response.Values);
                            }
                        });
                    }
                },
                isFilterable: (col: Slick.Column) => {
                    return col.sourceItem != null && col.sortable &&
                        (col.sourceItem.notFilterable == null || !col.sourceItem.notFilterable);
                }
            });

            filterPlugin.onFilterApplied.subscribe(() => {
                options.grid.refresh();
            });

            options.grid.slickGrid.registerPlugin(filterPlugin);

            var old = (options.grid as any).onViewSubmit;
            (options.grid as any).onViewSubmit = function () {
                if (!old.call(this))
                    return false;

                var cols = this.slickGrid.getColumns();
                var request = (this.view.params as ListRequest);
                for (var col of cols) {
                    if (col === skipColumnFilters)
                        continue;

                    var vals = col.filterValues;
                    if (vals && vals.length) {
                        var nonNull = vals.filter((z: any) => z != null);
                        var criteria = [[col.field], 'in', [nonNull]];
                        if (nonNull.length !== vals.length) {
                            if (nonNull.length > 0)
                                criteria = Serenity.Criteria.or(['is null', [col.field]], criteria);
                            else
                                criteria = ['is null', [col.field]];
                        }

                        request.Criteria = Serenity.Criteria.and(request.Criteria, criteria);
                    }
                }

                return true;
            };

        }
    }
}